import React from 'react';
import { Box, Typography } from '@mui/material';
import { ImgBox } from 'views/rebranded-module/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import StyledBox from 'views/rebranded-module/OffRoadToursLandingViewV2/components/HeroSection/HeroSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { Video } from 'views/rebranded-module/common/components';
import useLayoutHeights from 'views/rebranded-module/common/hooks/UseLayoutHeight';


const HeroSection = () => {
  const content = useContent('OffRoadLandingPage');
  const getSizedImage = useAdabtiveMultiSizeImage();
    const { LAYOUT_HEIGHT } = useLayoutHeights();
return (
    <StyledBox layoutHeight={LAYOUT_HEIGHT}>
      <Box className="HSBGContainer">
        <Video
          videoSrc={content.heroVideo.large_url.url}
          fallbackImg={{
            src: content.heroVideo.fallbackImage,
            alt: content.heroVideo.alt,
            width: '100%',
            height: '100%',
          }}
          className="HSVideo showLargeDESKTOP"
        />
         <Video
          videoSrc={content.heroVideo.small_url.url}
          fallbackImg={{
            src: content.heroVideo.fallbackImage,
            alt: content.heroVideo.alt,
            width: '100%',
            height: '100%',
          }}
          videoType='video/webm'
          className="HSVideo showMobileAndTabletAndDesktop"
        />
        <Box className="HSBGGradient" />
        <Box className="HSBGPattern">
          <ImgBox
            image={{
              src: getSizedImage(content.patternBackground),
              alt: content.patternBackground.alt,
            }}
            width="100%"
            height="100%"
            unoptimized
          />
        </Box>
      </Box>

      <Box className="HSContentContainer">
        <Typography variant="h3" component="h1" pb={2}>
          {content.heroTitle}
        </Typography>
        <Typography variant="body2" component="p" color="text.secondary">
          {content.heroSubTitle}
        </Typography>
      </Box>
    </StyledBox>
  );
};

export { HeroSection };
